import PropTypes from 'prop-types'
import { useEffect, useRef, useState } from 'react'
import EventEmitter, { SHOW_SINGLE_DATE } from '../../helpers/EventEmitter'
import { getInnerHeight } from '../../helpers/device'
import { HandleClickOutside } from '../HandleClickOutside'
import { Dropdown, positionDropdown } from '../dropdown'
import SingleDate from './SingleDate'
import './i18n'

const HEIGHT_CALENDAR = 300

const InputSingleDate = ({
  children,
  onSubmit,
  defaultDate,
  minDate,
  maxDate,
  scrollId,
}) => {
  const inputRef = useRef()

  const [isOpen, setIsOpen] = useState(false)
  const [position, setPosition] = useState(positionDropdown.BOTTOM_START_RIGHT)

  const onClick = () => {
    if (
      getInnerHeight() - inputRef.current.getBoundingClientRect().bottom <
      HEIGHT_CALENDAR
    ) {
      setPosition(positionDropdown.TOP_START_RIGHT)
    } else {
      setPosition(positionDropdown.BOTTOM_START_RIGHT)
    }
    setIsOpen(true)
  }

  const clickOutside = () => setIsOpen(false)

  const submit = (date) => {
    setIsOpen(false)
    onSubmit(date)
  }

  useEffect(() => {
    EventEmitter.subscribe(SHOW_SINGLE_DATE, setIsOpen)

    return () => {
      EventEmitter.unsubscribe(SHOW_SINGLE_DATE, setIsOpen)
    }
  }, [])

  return (
    <>
      <div onClick={onClick} ref={inputRef}>
        {children}
      </div>
      {isOpen && (
        <Dropdown
          parentRef={inputRef}
          position={position}
          scrollId={scrollId}
          setIsShow={setIsOpen}
        >
          <HandleClickOutside
            handleClickOutside={clickOutside}
            exceptRef={inputRef}
          >
            <SingleDate
              minDate={minDate}
              maxDate={maxDate}
              defaultDate={defaultDate}
              onSubmit={submit}
            />
          </HandleClickOutside>
        </Dropdown>
      )}
    </>
  )
}

InputSingleDate.propTypes = {
  children: PropTypes.node.isRequired,
  onSubmit: PropTypes.func.isRequired,
  defaultDate: PropTypes.any,
  minDate: PropTypes.any,
  maxDate: PropTypes.any,
  scrollId: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
}

InputSingleDate.defaultProps = {
  defaultDate: new Date(),
  minDate: new Date(1950, 0, 1),
  maxDate: new Date(2050, 0, 0),
}

export default InputSingleDate
